import React from 'react';
import {
  FDPrimaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { Alert } from 'Packages/FacetDesign/Components/Alert';

const RememberThisDeviceLayout = ({
  onSubmit, resource, handleChange, saving,
}) => {
  const handleDecline = () => {
    handleChange('shouldRememberMe', false);
    onSubmit();
  };

  const handleEnable = () => {
    handleChange('shouldRememberMe', true);
    onSubmit();
  };

  return (
    <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={3}>
      <MetaControlField attr={'title'} data-test={`user-auth-setup-title-${resource.type()}`} />
      <Alert status={'warning'} title={resource.attr('subTextTitle')} description={resource.attr('subText')} />
      <MetaControlField attr={'primaryText'} />
      <FDStack direction={'column'} alignItems={'center'} spacing={2}>
        <FDPrimaryActionButton
          loading={saving}
          label={resource.attr('optInButtonText')}
          onClick={handleEnable}
          test={'user-auth-setup-remember-this-device-button'}
        />
        <FDTextButton
          disabled={saving}
          label={resource.attr('optOutButtonText')}
          onClick={handleDecline}
          data-test={'user-auth-setup-do-not-remember-this-device-button'}
        />
      </FDStack>
    </FDStack>
  );
};

RememberThisDeviceLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
  saving: PropTypes.bool,
};

RememberThisDeviceLayout.defaultProps = {
  saving: false,
};

export default RememberThisDeviceLayout;
